var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    [
      _c(
        "div",
        {
          staticClass: "container mw-960",
          attrs: { slot: "layout-body" },
          slot: "layout-body"
        },
        [
          _c("div", { staticClass: "error-container text-center" }, [
            _c("img", {
              attrs: { src: "/static/images/signin-lcic-inactive.svg" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "typography--content-body",
              domProps: { innerHTML: _vm._s(_vm.$t("errors.not_found_msg")) }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("AppFooter", { attrs: { slot: "footer" }, slot: "footer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce5b7f86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce5b7f86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/errors/views/NotFound.vue
// module id = JsV8
// module chunks = 1